document.addEventListener('DOMContentLoaded', function () {
  const elements = document.querySelectorAll('.tab-content-inner-text');

  elements.forEach((element) => {
    const encodedContent = element.innerHTML;
    const decodedContent = encodedContent
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
    element.innerHTML = decodedContent;
  });

  document.querySelectorAll('.tab-content-inner-text').forEach((element) => {
    element.querySelectorAll('br').forEach((br) => br.remove());
  });

  document.querySelectorAll('.tab-content-inner-text p').forEach((p) => {
    if (!p.textContent.trim() && !p.querySelector('*')) {
      p.style.display = 'none';
    }
  });

  document.querySelectorAll('.tab-content-inner-text p').forEach((p) => {
    const multiLineElement = p.querySelector(
      '.metafield-multi_line_text_field'
    );
    if (multiLineElement && !multiLineElement.textContent.trim()) {
      p.remove();
    }
  });
});
